import { FirebaseMediaElementModel } from "./mediaElement.model";
import { undefinedToNull } from '../utilities';


export class FirebasePuntoTourModel {

    
    coord: {lat: number, lng: number};
    titulo: string;
    elementosMedia: FirebaseMediaElementModel[];
    

    constructor(titulo?: string, coord?: {lat: number, lng: number}) {
        this.coord= coord || null;
        this.titulo= titulo || '';
        this.elementosMedia= [];
    }

    toObject() {
        return Object.assign({}, this);
    }

    preparePTObject(){
        var elementosMediaObject=[] 
        this.elementosMedia.forEach(elementoMedia =>{            
            elementosMediaObject.push(elementoMedia.prepareMEObject())
        })       
        
        var puntoTourObject = this.toObject();
        puntoTourObject.elementosMedia=elementosMediaObject;
        
        return puntoTourObject;
    }

    static objectPTtoModel(puntoTour){
        var tourPT = new FirebasePuntoTourModel(puntoTour.titulo,puntoTour.coord);
        puntoTour.elementosMedia.forEach(elementoMedia =>{            
            tourPT.elementosMedia.push(FirebaseMediaElementModel.objectMEtoModel(elementoMedia))
        }) 
        return tourPT;
    }
}